var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F3440",
    d: "M14.392 7.307v-2.2c0-1.858-1.758-3.366-3.925-3.366h-.942C7.358 1.74 5.6 3.249 5.6 5.107v2.225a2.83 2.83 0 0 0-2.008 2.7v5.384a2.845 2.845 0 0 0 2.841 2.841h7.217a2.845 2.845 0 0 0 2.842-2.841v-5.384a2.835 2.835 0 0 0-2.1-2.733zM9.533 3.416h.942c1.225 0 2.258.775 2.258 1.7v2.091h-5.45V5.116c0-.917 1.034-1.7 2.259-1.7zm1.034 10.825v1.225c0 .241-.2.441-.442.441H9.65a.445.445 0 0 1-.442-.441V14.24a1.41 1.41 0 0 1-.733-1.234c0-.783.633-1.416 1.417-1.416.783 0 1.417.633 1.417 1.416 0 .534-.3.992-.734 1.234z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F3440",
    d: "M0 .082h20v20H0z"
  })))));
};
export default SvgLock;